import React, { useEffect } from 'react';

import { Boxed } from '../../components/Boxed.components';
import { Text } from '../../components/Text.components';
import { Button } from '../../components/Button.components';
import { Badge } from '../../components/Badge.components';
import { Loader } from '../../components/Loader.components';
import { Grid } from '../../components/Grid.components';
import { HR, Icon, PageTitle } from '../../components/style';
import { Avatar } from '../../components/Avatar.components';
import { formatDate } from '../../utils/utils';
import { Theme } from '../../utils/theme';
import { Tab, Tabs } from 'react-bootstrap';
import { FormDisplay } from './FormDisplay';

import Comment from './Comment';
import Activities from './Activities';
import DecisionModal from './ConfirmationModal/index';
import { RenderStatus } from '../Applications/style';

const ReviewerSection = ({ defaultList, additionalList }) => {
  return (
    <Boxed pad="10px" background={Theme.TertiaryDark} borderRadius={Theme.PrimaryRadius}>
      {defaultList?.length > 0 && (
        <>
          <Text
            fontSize={Theme.SecondaryFontSize}
            color={Theme.SecondaryTextColor}
            fontWeight="600"
          >
            Default Reviewer
          </Text>
          {defaultList?.map((item, index) => {
            let iconTag = '';
            let iconColor = '';
            switch (item?.review) {
              case 'approved':
                iconTag = 'icon-ok-circle';
                iconColor = Theme.PrimaryGreen;
                break;
              case 'change-requested':
                iconTag = 'icon-attention';
                iconColor = Theme.PrimaryYellow;
                break;
              case 'declined':
                iconTag = 'icon-cancel-circled-1';
                iconColor = Theme.PrimaryRed;
                break;
              default:
                break;
            }
            return (
              <Grid desktop="15px 40px auto" tablet="15px 40px auto" mobile="15px 40px auto">
                <Boxed display="flex">
                  <Icon className={iconTag} color={iconColor} margin="auto" />
                </Boxed>
                <Avatar
                  key={index}
                  src={item?._id?.profilePictureUrl}
                  title={`${item?._id?.lastName} ${item?._id?.firstName}`}
                  size="38px"
                />

                <Boxed display="flex">
                  <Text margin="auto 0" fontSize={Theme.SecondaryFontSize}>
                    {item?._id?.lastName} {item?._id?.firstName}
                  </Text>
                </Boxed>
              </Grid>
            );
          })}
          <HR />
        </>
      )}
      {additionalList?.length > 0 && (
        <>
          <Text
            fontSize={Theme.SecondaryFontSize}
            color={Theme.SecondaryTextColor}
            fontWeight="600"
          >
            Additional Reviewer
          </Text>
          {additionalList?.map((item, index) => {
            let iconTag = '';
            let iconColor = '';
            switch (item?.review) {
              case 'approved':
                iconTag = 'icon-ok-circle';
                iconColor = Theme.PrimaryGreen;
                break;
              case 'change-requested':
                iconTag = 'icon-attention';
                iconColor = Theme.PrimaryYellow;
                break;
              case 'declined':
                iconTag = 'icon-cancel-circled-1';
                iconColor = Theme.PrimaryRed;
                break;
              default:
                break;
            }

            return (
              <Grid desktop="15px 40px auto" tablet="15px 40px auto" mobile="15px 40px auto">
                <Boxed display="flex">
                  <Icon className={iconTag} color={iconColor} margin="auto" />
                </Boxed>
                <Avatar
                  key={index}
                  src={item?._id?.profilePictureUrl}
                  title={`${item?._id?.lastName} ${item?._id?.firstName}`}
                  size="38px"
                />

                <Boxed display="flex">
                  <Text margin="auto 0" fontSize={Theme.SecondaryFontSize}>
                    {item?._id?.lastName} {item?._id?.firstName}
                  </Text>
                </Boxed>
              </Grid>
            );
          })}
        </>
      )}
    </Boxed>
  );
};

export const ReviewRequest = (props) => {
  // state props
  const { applicationData, params, isLoading, profile } = props;

  // dispatch props
  const { fetchSingleApplication, redirect, openDecisionModal } = props;

  useEffect(() => {
    if (params?.id) {
      fetchSingleApplication({ id: params?.id });
    }
  }, [params?.id]);

  let isReviewer = false;
  let isApproved = false;
  let isChangeRequested = false;
  let isDeclined = false;

  const changeRequestedList = [];
  const stepCriteria = [];
  const defaultList = [];
  applicationData?.reviewers?.forEach((item, index) => {
    stepCriteria.push({
      step: index + 1,
      criteriaOfAcceptance: item?.criteriaOfAcceptance,
      passed: applicationData?.currentStage > item?.step
    });

    if (item?.step === applicationData?.currentStage) {
      item?.reviewers?.forEach((user) => {
        if (user?._id) {
          defaultList.push(user);
        }

        if (user?._id?._id === profile?._id) {
          isReviewer = true;
          switch (user?.review) {
            case 'approved':
              isApproved = true;
              break;
            case 'change-requested':
              isChangeRequested = true;
              break;
            case 'declined':
              isDeclined = true;
              break;
            default:
              break;
          }
        }

        if (user?.review === 'change-requested') {
          changeRequestedList.push(user);
        }
      });
    }
  });

  const additionalList = [];
  applicationData?.additionalReviewers?.forEach((user) => {
    const existInDefault = defaultList?.findIndex(item => item?._id?._id === user?._id?._id);
    if(existInDefault > -1 ) { 
      return null
    }
    
    if (user?._id) {
      additionalList.push(user);
    }

    if (user?._id?._id === profile?._id) {
      isReviewer = true;
      switch (user?.review) {
        case 'approved':
          isApproved = true;
          break;
        case 'change-requested':
          isChangeRequested = true;
          break;
        case 'declined':
          isDeclined = true;
          break;
        default:
          break;
      }
    }

    if (user?.review === 'change-requested') {
      changeRequestedList.push(user);
    }
  });

  console.log({ changeRequestedList });

  return (
    <>
      <Boxed pad="20px">
        <PageTitle>Review / {applicationData?._id}</PageTitle>
        {isLoading ? (
          <Boxed display="flex" pad="20px">
            <Loader margin="0 auto" />
          </Boxed>
        ) : (
          <>
            <Boxed pad="10px 0">
              <Avatar
                size="38px"
                src={applicationData?.createdBy?.profilePictureUrl}
                name={`${applicationData?.requestTitle?.title}`}
                info={`By ${applicationData?.createdBy?.lastName} ${
                  applicationData?.createdBy?.firstName
                } - on the ${
                  applicationData?.createdAt && formatDate(applicationData?.createdAt)
                }, Last updated on ${
                  applicationData?.createdAt && formatDate(applicationData?.createdAt)
                }`}
                status={<RenderStatus status={applicationData?.status} />}
              />
            </Boxed>

            {isReviewer &&
              (applicationData?.status === 'open' ||
                applicationData?.status === 'change-requested') && (
                <Boxed pad="10px 0">
                  <Button
                    color={isChangeRequested ? '#D8E4F1' : '#EAE9E9'}
                    fontColor={Theme.PrimaryTextColor}
                    small={true}
                    onClick={() => openDecisionModal(isChangeRequested ? 'Unrequest Change' : 'Request Change')}
                    // disabled={isChangeRequested}
                  >
                    <Icon className="icon-attention" color={Theme.PrimaryYellow} />{' '}
                    {isChangeRequested ? 'Unrequest Change' : 'Request Change'}
                  </Button>
                  {!isApproved ? (
                    <Button
                      color={'#EAE9E9'}
                      fontColor={Theme.PrimaryTextColor}
                      small={true}
                      onClick={() => openDecisionModal('Approve')}
                    >
                      <Icon className="icon-ok-circle" color={Theme.PrimaryGreen} /> Approve
                    </Button>
                  ) : (
                    <Button
                      color={'#D8E4F1'}
                      fontColor={Theme.PrimaryTextColor}
                      small={true}
                      onClick={() => openDecisionModal('Unapprove')}
                    >
                      <Icon className="icon-thumbs-down-1" color={Theme.PrimaryGreen} /> Unapprove
                    </Button>
                  )}
                  <Button
                    color={'#EAE9E9'}
                    fontColor={Theme.PrimaryTextColor}
                    small={true}
                    onClick={() => openDecisionModal('Decline')}
                  >
                    <Icon className="icon-cancel-circled-1" color={Theme.PrimaryRed} /> Decline
                  </Button>
                </Boxed>
              )}

            {(changeRequestedList?.length > 0) && (
              <Boxed
                margin="5px 0"
                pad="10px"
                borderRadius={Theme.PrimaryRadius}
                background={`${Theme.PrimaryYellow}30`}
                border={`0.5px dashed ${Theme.PrimaryYellow}80`}
              >
                <Text fontWeight="600" fontSize={Theme.SecondaryFontSize}>
                  {' '}
                  Changes Requested{' '}
                </Text>

                {changeRequestedList?.map((item, index) => (
                  <Grid key={index} desktop="15px auto" tablet="15px auto" mobile="15px auto">
                    <Boxed display="flex">
                      <Icon
                        className={'icon-attention'}
                        color={Theme.PrimaryYellow}
                        margin="auto"
                      />
                    </Boxed>
                    <Avatar
                      key={index}
                      src={item?._id?.profilePictureUrl}
                      name={item?.observation}
                      info={`By ${item?._id?.lastName} ${item?._id?.firstName}`}
                      size="38px"
                    />
                  </Grid>
                ))}
              </Boxed>
            )}

            <Grid desktop="auto 280px" tablet="auto 280px" mobile="auto 280px">
              <Boxed>
                <Tabs defaultActiveKey="RequestForm" id="uncontrolled-tab-example" className="mb-3">
                  <Tab eventKey="RequestForm" title="Request Form">
                    <FormDisplay applicationData={applicationData} />
                  </Tab>
                  <Tab eventKey="Comments" title="Comments">
                    <Comment applicationData={applicationData} />
                  </Tab>
                  <Tab eventKey="Activities" title="Activities">
                    <Activities applicationData={applicationData} />
                  </Tab>
                </Tabs>
              </Boxed>
              <Boxed>
                <Text>
                  Current Stage{' '}
                  <span style={{ fontSize: '20px', color: Theme.PrimaryColor }}>
                    {applicationData?.currentStage}
                  </span>
                  /{applicationData?.stages}
                </Text>
                <Boxed
                  margin="5px 0"
                  pad="20px"
                  borderRadius={Theme.SecondaryRadius}
                  background={Theme.TertiaryDark}
                >
                  <Text fontWeight="600" fontSize={Theme.SecondaryFontSize}>
                    Request Criteria of Acceptance
                  </Text>
                  {stepCriteria?.map((item, index) => {
                    return (
                      <Grid
                        key={index}
                        padding="5px 0"
                        desktop="30px auto"
                        tablet="30px auto"
                        mobile="30px auto"
                      >
                        <Icon
                          margin="auto"
                          color={Theme.PrimaryGreen}
                          className={item?.passed ? 'icon-ok-circle' : ''}
                        />
                        <Text>
                          Step <b>{item?.step}</b> requires a mininum of{' '}
                          <b>{item?.criteriaOfAcceptance ?? 0}</b> approval from default reviewers.
                        </Text>
                      </Grid>
                    );
                  })}
                </Boxed>
                <ReviewerSection defaultList={defaultList} additionalList={additionalList} />
              </Boxed>
            </Grid>
            <DecisionModal applicationData={applicationData} />
          </>
        )}
      </Boxed>
    </>
  );
};
